module.exports = __webpack_public_path__ + "static/media/boycott.917c3edc.jpg";